export function Spinner({ label = "載入中" }: { label?: string }) {
  return <div className="spinner-border text-primary" role="status"><span className="sr-only">{label}</span></div>;
}

